import Image from 'next/image';
import type { Brand } from './brands';
import datatamerLogo from '../../../public/images/logo-indigo.png';

/**
 * Header shown above the login form. When an external app authenticates its users
 * through Datatamer (e.g. the MeOnSteroids desktop client via /desktop-auth?brand=...),
 * it renders that app's branding; otherwise the default dataTamer header.
 */
export function AuthHeader({ brand }: { brand?: Brand | null }) {
  if (brand) {
    return (
      <div className="flex flex-col items-center mb-5 text-center">
        <div className="mb-3">{brand.logo}</div>
        <h2 className="text-2xl font-bold text-foreground">{brand.name}</h2>
        <p className="text-sm text-muted-foreground mt-1">{brand.tagline}</p>
        <p className="text-[11px] text-muted-foreground/70 mt-2">Powered by Datatamer</p>
      </div>
    );
  }
  return (
    <div className="flex items-center mb-4">
      <Image alt="dataTamer logo" src={datatamerLogo} className="w-9 h-auto" />
      <h2 className="text-3xl font-bold ml-4 text-muted-foreground">dataTamer</h2>
    </div>
  );
}
